import React, { FC } from 'react';
import Picture from '../../@shared/picture';
import { THeroBannerSeriesDetailMediaImageHeroAsset } from '../types/productHeroBannerSeriesDetail.types';

const ImageHeroAsset: FC<THeroBannerSeriesDetailMediaImageHeroAsset> = (props) => {
  const { model } = props;
  
  return (
    <Picture
      productImageProps={{
        desktopRendition: model.desktopImageHeroAsset || model.rendition_desktop_size1900,
        desktopSDRendition: model.desktopSDImageHeroAsset || model.rendition_desktop_size1200,
        tabletLandscapeRendition: model.tabletLandscapeHeroAsset || model.rendition_tablet_size1000,
        tabletRendition: model.tabletPotraitHeroAsset || model.rendition_tablet_size1200,
        mobileRendition: model.mobileImageHeroAsset || model.rendition_mobile_size1100,
        imageClassName: 'hero-banner__image',
        disableLazyLoad: true,
        alt: model.title,
        prioritize: true,
      }}
    />
  );
};

export default ImageHeroAsset;